import { render, staticRenderFns } from "./DialogAllergenSetting.vue?vue&type=template&id=29d635a6&scoped=true&"
import script from "./DialogAllergenSetting.vue?vue&type=script&lang=js&"
export * from "./DialogAllergenSetting.vue?vue&type=script&lang=js&"
import style0 from "./DialogAllergenSetting.vue?vue&type=style&index=0&id=29d635a6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29d635a6",
  null
  
)

export default component.exports